"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {};
  },
  computed: {
    searchTitle: {
      get: function get() {
        return this.$store.getters.searchAttendancWord;
      },
      set: function set(val) {
        this.$store.dispatch('client/setSearchAttendance', val);
      }
    }
  },
  methods: {
    searchAttendanceForm: function () {
      var _searchAttendanceForm = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log('searchAttendanceForm');
              _context.next = 1;
              return this.$store.dispatch('client/setPageTop', 0);
            case 1:
              _context.next = 2;
              return this.$store.dispatch('client/fetchClientsAttendance', (0, _auth.getClientID)());
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function searchAttendanceForm() {
        return _searchAttendanceForm.apply(this, arguments);
      }
      return searchAttendanceForm;
    }()
  }
};